import axios from 'axios';
import { AxiosResponse } from '@/interface';

export const instance = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

if (process.env.NODE_ENV === 'test') {
  instance.defaults.baseURL = 'https://staging-io.labsby.com/api';
} else if (process.env.NODE_ENV === 'production') {
  instance.defaults.baseURL = 'https://io.labsby.com/api';
}

instance.interceptors.response.use(
  (response: AxiosResponse<any>) => {
    return response;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

export default instance;
